import { Button, Tooltip } from "@appkit4/react-components";
import { useMemo } from "react";
import "./customTooltipIcon.scss";

const CustomTooltipIcon = ({ size, tooltipText, delay = 0 }) => {
  const delayInMilliseconds = delay * 1000;

  const addBulletList = (elements, list) => {
    if (list.length > 0) {
      elements.push(
        <ul style={{ marginBottom: "20px" }}>
          {list.map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>,
      );
    }
    return [];
  };

  const memoizedContent = useMemo(() => {
    const elements = [];
    let currentList = [];

    if (!Array.isArray(tooltipText)) return tooltipText;

    tooltipText.forEach((paragraph, index) => {
      const isBullet = paragraph.trim().startsWith("•");

      if (isBullet) {
        currentList.push(paragraph.replace("•", ""));
      } else {
        currentList = addBulletList(elements, currentList);

        const containsLink = paragraph.includes("https");
        elements.push(
          containsLink ? (
            <p dangerouslySetInnerHTML={{ __html: paragraph }} />
          ) : (
            <p key={`p-${index}`} className="margin-bottom">
              {paragraph}
            </p>
          ),
        );
      }
    });

    currentList = addBulletList(elements, currentList);

    return <div className="no-margin-last">{elements}</div>;
  }, []);

  return (
    <Tooltip
      className={size === "big" ? "big-tooltip" : ""}
      content={memoizedContent}
      mouseLeaveDelay={delayInMilliseconds}
    >
      <Button
        className="icon-btn"
        icon="icon-information-outline"
        kind="text"
      />
    </Tooltip>
  );
};

export default CustomTooltipIcon;
